import * as React from "react";
import { Badge } from "components/bootstrap";
import usePermissions from "hooks/usePermissions";
import useNotificationBadgeCount from "components/notifications/hooks/useNotificationBadgeCount";
const NotificationsNavTab = ({ text }) => {
  const { isPermitted } = usePermissions();
  const enabled = isPermitted("notifications:read");
  const { data, isLoading } = useNotificationBadgeCount({ enabled });
  const showBadge = !isLoading && !!data;
  return /* @__PURE__ */ React.createElement("span", null, text, showBadge && /* @__PURE__ */ React.createElement(React.Fragment, null, " ", /* @__PURE__ */ React.createElement(Badge, { bsStyle: "danger" }, data)));
};
export default NotificationsNavTab;
